<template>
  <div id="app" :class="'lang-' + $i18n.locale">
    <div class="app-c">
      <header class="index_hader">
        <router-link to="/">
          <div class="logo"></div>
        </router-link>
        <nav>
          <ul>
            <router-link to="/">
              <li>{{ $t('nav.home') }}</li>
            </router-link>
            <router-link to="/about">
              <li>{{ $t('nav.about') }}</li>
            </router-link>
            <router-link to="/case">
              <li>{{ $t('nav.case') }}</li>
            </router-link>
            <router-link to="/team">
              <li>{{ $t('nav.team') }}</li>
            </router-link>
            <router-link to="/culture">
              <li>{{ $t('nav.culture') }}</li>
            </router-link>
            <router-link to="/address">
              <li>{{ $t('nav.contact') }}</li>
            </router-link>
            <a href="#" @click.prevent="switchLanguage"><li>{{ $t('nav.language') }}</li></a>
          </ul>
        </nav>
        <!-- add -->
        <el-button
          class="drawer-top"
          @click="openDrawer"
          @touchstart="openDrawer"
          icon="el-icon-more"
        ></el-button>
        <!-- add -->
      </header>
      <router-view></router-view>
      <footer class="site-footer">
        <div class="footer-main">
          <!-- Brand Column -->
          <div class="footer-brand">
            <div class="footer-logo"></div>
            <p class="footer-tagline">{{ $i18n.locale === 'zh' ? yearsSince + '年专注汽车技术服务' : yearsSince + ' Years of Automotive Technical Excellence' }}</p>
            <div class="footer-contact">
              <div class="contact-row">
                <span class="contact-icon">📞</span>
                <span>138 0712 1650</span>
              </div>
              <div class="contact-row">
                <span class="contact-icon">📞</span>
                <span>152 0270 8329</span>
              </div>
              <div class="contact-row">
                <span class="contact-icon">✉️</span>
                <span>mail@forcartech.com</span>
              </div>
            </div>
          </div>
          <!-- Link Columns -->
          <div class="footer-links">
            <div class="footer-col">
              <h4>{{ $t('footer.aboutTitle') }}</h4>
              <router-link to="/about">{{ $t('footer.companyProfile') }}</router-link>
              <router-link to="/case">{{ $t('footer.projectCase') }}</router-link>
              <router-link to="/about">{{ $t('footer.patentCert') }}</router-link>
            </div>
            <div class="footer-col">
              <h4>{{ $t('footer.joinTitle') }}</h4>
              <a target="_blank" href="https://www.zhaopin.com/companydetail/%E6%AD%A6%E6%B1%89%E7%A6%8F%E5%8D%A1%E8%BF%AA%E6%B1%BD%E8%BD%A6%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8_CC194600711.htm">{{ $t('footer.zhilian') }}</a>
              <a target="_blank" href="https://www.zhipin.com/gongsir/b4b8c715ba65a4581nN-2du1FQ~~.html?ka=job-detail-company_custompage">{{ $t('footer.boss') }}</a>
            </div>
            <div class="footer-col">
              <h4>{{ $t('footer.contactTitle') }}</h4>
              <router-link to="/address">{{ $t('footer.companyAddress') }}</router-link>
            </div>
          </div>
          <!-- QR Code -->
          <div class="footer-qr">
            <img src="./assets/img/code.webp" alt="QR" />
            <span>{{ $t('footer.qrcode') }}</span>
          </div>
        </div>
        <div class="footer-beian">
          <img src="./assets/img/国徽.png" alt="" class="beian-icon" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=42011302001009" rel="noreferrer" target="_blank">鄂公网安备42011302001009号</a>
          <span>|</span>
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">鄂ICP备19018302号-1</a>
        </div>
      </footer>
    </div>
    <!-- add -->
    <el-drawer
      class="drawerBox"
      :modal="false"
      title=""
      :visible.sync="drawer"
      :direction="direction"
    >
      <ul>
        <router-link to="/" @click.native="handleClickClose">
          <li>{{ $t('nav.home') }}</li>
        </router-link>
        <router-link to="/about" @click.native="handleClickClose">
          <li>{{ $t('nav.about') }}</li>
        </router-link>
        <router-link to="/case" @click.native="handleClickClose">
          <li>{{ $t('nav.case') }}</li>
        </router-link>
        <router-link to="/team" @click.native="handleClickClose">
          <li>{{ $t('nav.team') }}</li>
        </router-link>
        <router-link to="/culture" @click.native="handleClickClose">
          <li>{{ $t('nav.culture') }}</li>
        </router-link>
        <router-link to="/address" @click.native="handleClickClose">
          <li>{{ $t('nav.contact') }}</li>
        </router-link>
        <a href="#" @click.prevent="switchLanguage"><li>{{ $t('nav.language') }}</li></a>
      </ul>
    </el-drawer>
    <!-- add -->
    <el-backtop style="background-color: #00000000" :bottom="100" :right="12">
      <div
        style="
          height: 100%;
          width: 100%;
          background-color: #ff0000;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
          text-align: center;
          color: #fff;
          border-radius: 8px;
        "
      >
        <img src="./assets/img/top02.svg" alt="" />
      </div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  computed: {
    yearsSince() {
      return new Date().getFullYear() - 2008;
    },
  },
  data() {
    return {
      direction: "ttb",
      drawer: false,
    };
  },
  watch: {
    drawer(val) {
      if (val) {
        // Lock body scroll to prevent page scrolling while drawer is open
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        // Blur active element on next tick so focus highlight clears
        this.$nextTick(() => {
          if (document.activeElement) {
            document.activeElement.blur();
          }
        });
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    },
  },
  methods: {
    openDrawer() {
      this.drawer = true;
    },
    handleClickClose() {
      this.drawer = false;
    },
    switchLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLang;
      this.$store.commit('setLocale', newLang);
      this.drawer = false;
    },
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  user-select: none;
  font-family: "PFSC S";
}

.el-image-viewer__btn {
  display: none !important;
}

a {
  text-decoration: none;
}

.app-c {
  max-width: 2160px;
  margin: 0 auto;
}

html body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

// Disable hover transforms/shadows on touch devices (no hover capability)
@media (hover: none) {
  .team-card:hover,
  .value-card:hover,
  .contact-card:hover,
  .category-tab:hover,
  .gallery-item:hover,
  .ability8-logo:hover,
  .ablity2-data-li:hover,
  .ability5-main-li:hover,
  .brand-item:hover,
  .thumb-item:hover,
  .footer-btn:hover,
  .btn-box1:hover,
  .btn-box2:hover,
  .btn-box3:hover,
  .stat-item:hover,
  .toggle-btn:hover {
    transform: none !important;
  }
}

.p1 {
  max-width: 1150px;
  width: 100%;
  padding: 0 20px;
  margin: 70px auto 0;
  font-size: 40px;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-top: 40px;
  }

  .lang-en & {
    font-size: 32px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  .col {
    color: var(--red-color);
  }

  span {
    display: inline-block;
    letter-spacing: 5px;
    margin-left: 5px;
  }
}

.p2 {
  max-width: 1150px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  margin-top: 17px;

  .lang-en & {
    font-size: 14px;
  }
}

// English hero text layout
.p2-title {
  .lang-en & {
    font-size: 15px;
    line-height: 1.7;
    text-align: left;
    max-width: 1150px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .p2-col {
    color: var(--red-color);
    font-size: 32px;
    display: block;
    margin-bottom: 8px;
  }

  .p2-col-1 {
    display: block;
    margin-bottom: 10px;
  }
}


//add
.drawerBox {
  ul {
    padding: 0;
    margin: 0;
    a {
      text-decoration: none;
      color: inherit;
      li {
        list-style: none;
        margin-top: 15px;
        color: #fff;
        font-size: 18px;
      }
    }
  }
}
//add
.el-drawer {
  height: 50% !important;
  background: rgba(0, 0, 0, 0.5) !important;
  // backdrop-filter only on devices with hover (desktop).
  // On iOS touch devices, backdrop-filter on position:fixed creates
  // a GPU compositor layer that blocks click events across the page.
  @media (hover: hover) {
    backdrop-filter: blur(0.808333rem) !important;
  }
}
//add
.el-drawer__header {
  margin-bottom: 20px !important;
}
//add
.router-link-exact-active {
  @media (max-width: 768px) {
    position: relative;
    .logo {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      // width: 80px !important;
    }
  }
}
//add

.index_hader {
  width: 100%;
  max-width: 2160px;
  min-width: auto;
  height: 60px;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid rgba(233, 231, 231, 0.6);

  // Use a pseudo-element for backdrop-filter to prevent iOS Safari
  // from creating a GPU compositor layer that blocks child click events.
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: saturate(150%) blur(0.808333rem);
    -webkit-backdrop-filter: saturate(150%) blur(0.808333rem);
    z-index: -1;
  }
  //add
  .drawer-top {
    display: none;
    position: absolute;
    right: 10px;
    height: 100%;
    width: 30px;
    padding: 0;
    margin: 0;
    border: 0;
    color: #ddd1d1;
    background-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    z-index: 1;

    // Nuke every possible focus / active / click highlight from Element UI
    &:focus,
    &:active,
    &:hover,
    &:visited,
    &.el-button:focus,
    &.el-button:active,
    &.el-button:hover,
    &.el-button--default:focus,
    &.el-button--default:active {
      color: #ddd1d1 !important;
      border: 0 !important;
      outline: none !important;
      background-color: rgba(0, 0, 0, 0) !important;
      background-image: none !important;
      box-shadow: none !important;
      -webkit-tap-highlight-color: transparent !important;
    }
    @media (hover: hover) {
      &:hover {
        color: #ddd1d1;
        border: 0;
        background-color: rgba(0, 0, 0, 0);
      }
    }
    @media (max-width: 1000px) {
      display: inline-block;
    }
  }
  //add

  .logo {
    margin-left: 15px;
    width: 160px;
    height: 100%;
    float: left;
    background-image: url("./assets/img/LOGO.svg");
    background-size: 98%;
    background-position: center;
    background-repeat: no-repeat;
    //add
    @media (max-width: 768px) {
      width: 80px;
    }
    //add
  }

  nav {
    height: 100%;
    max-width: 1100px;
    width: auto;
    float: right;
    margin-right: 120px;
    // 1400px: first reduction - narrower items to fit smaller screens
    @media (max-width: 1400px) {
      margin-right: 50px;
    }
    // 1200px: switch to flexible mode so items always fit
    @media (max-width: 1200px) {
      margin-right: 15px;
      max-width: 100%;
    }
    //add
    @media (max-width: 1000px) {
      display: none;
    }
    //add

    ul {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      margin: 0;
      padding: 0;
      list-style: none;
      justify-content: space-around;
      align-items: center;

      li {
        position: relative;
        width: 150px;
        flex: none;
        line-height: 40px;
        color: aliceblue;
        padding: 10px;
        font-size: 15px;
        white-space: nowrap;
        text-align: center;
        // 1400px: narrower fixed-width items
        @media (max-width: 1400px) {
          width: 115px;
          font-size: 14px;
          padding: 10px 4px;
        }
        // 1200px: flexible items that share available space
        @media (max-width: 1200px) {
          width: auto;
          flex: 1;
          font-size: 13px;
          padding: 10px 3px;
          min-width: 60px;
        }

        // background-color:red;
        &::before {
          content: "";
          width: 0;
          height: 2px;
          background-color: #d53434;
          position: absolute;
          left: 0;
          bottom: 0;
          transition: all 0.5s ease;
          -webkit-transition: all 0.5s ease;
          @media (max-width: 768px) {
            display: none;
          }
        }

        @media (hover: hover) {
          &:hover {
            cursor: pointer;

            &::before {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .index_hader {
    max-width: auto;
    min-width: auto;
    display: flex;
    height: 50px;

    // .logo {
    //   margin-top: -3px;
    //   margin-left: 0;
    //   width: 80px;
    // }

    nav {
      ul {
        width: 300px;
        padding-left: 0;

        li {
          line-height: 8px;
          font-size: 6px;
        }
      }
    }
  }
}

// ========== Footer ==========
.site-footer {
  background: #141428;
  color: rgba(255,255,255,0.65);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #d53434, #e84747, #d53434);
  }

  a {
    color: rgba(255,255,255,0.5);
    text-decoration: none;
    transition: color 0.2s, padding-left 0.2s;
    font-size: 13px;
    position: relative;

    &:hover {
      color: #fff;
      padding-left: 4px;
    }

    .lang-en & { font-size: 11px; }
  }
}

.footer-main {
  max-width: 1150px;
  width: 100%;
  margin: 0 auto;
  padding: 56px 24px 44px;
  display: flex;
  gap: 48px;

  @media (max-width: 1000px) {
    flex-wrap: wrap;
    gap: 28px;
    padding: 40px 20px 32px;
  }
}

// Brand Column
.footer-brand {
  flex-shrink: 0;
  width: 260px;
  padding-right: 32px;
  border-right: 1px solid rgba(255,255,255,0.06);

  @media (max-width: 1000px) {
    width: 100%;
    padding-right: 0;
    border-right: none;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
}

.footer-logo {
  width: 150px;
  height: 40px;
  background-image: url("./assets/img/LOGO.svg");
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
  margin-bottom: 14px;
  filter: brightness(1.1);
}

.footer-tagline {
  font-size: 13px;
  color: rgba(255,255,255,0.35);
  margin: 0 0 22px;
  line-height: 1.5;
  letter-spacing: 0.5px;

  .lang-en & { font-size: 11px; }

  @media (max-width: 1000px) { margin-bottom: 16px; }
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(255,255,255,0.55);
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(255,255,255,0.03);
  transition: background 0.2s;

  &:hover { background: rgba(255,255,255,0.06); }

  .lang-en & { font-size: 11px; }

  @media (max-width: 600px) { font-size: 12px; }
}

.contact-icon {
  font-size: 14px;
  flex-shrink: 0;
  opacity: 0.7;
}

// Link Columns
.footer-links {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

.footer-col {
  h4 {
    color: #fff;
    font-size: 14px;
    margin: 0 0 18px;
    font-weight: 600;
    letter-spacing: 0.5px;

    &::after {
      content: '';
      display: block;
      width: 20px;
      height: 2px;
      background: #d53434;
      margin-top: 8px;
      border-radius: 1px;
    }

    .lang-en & { font-size: 12px; }

    @media (max-width: 600px) {
      font-size: 13px;
      margin-bottom: 12px;
      &::after { margin-top: 6px; }
    }
  }

  a {
    display: block;
    margin-bottom: 9px;

    @media (max-width: 600px) { margin-bottom: 7px; }
  }
}

// QR Code
.footer-qr {
  flex-shrink: 0;
  text-align: center;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255,255,255,0.03);

  @media (max-width: 1000px) {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    text-align: left;
    padding: 16px;
  }

  img {
    width: 90px;
    height: 90px;
    border-radius: 8px;
    display: block;
    margin: 0 auto 10px;
    padding: 4px;
    background: #fff;

    @media (max-width: 1000px) {
      width: 60px;
      height: 60px;
      margin: 0;
      padding: 3px;
    }
  }

  span {
    font-size: 11px;
    color: rgba(255,255,255,0.4);
    .lang-en & { font-size: 10px; }
  }
}

// Beian
.footer-beian {
  border-top: 1px solid rgba(255,255,255,0.05);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  background: rgba(0,0,0,0.25);

  .beian-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    opacity: 0.5;
  }

  a, span {
    font-size: 12px;
    color: rgba(255,255,255,0.28);

    @media (max-width: 600px) { font-size: 10px; }
  }

  a:hover { color: rgba(255,255,255,0.5); }
}

// 修改图片预览放大后的默认大小
.el-image-viewer__wrapper .el-image-viewer__canvas .el-image-viewer__img {
  transform: scale(0.8) rotate(0deg) !important;
}

/* 设置滚动条的宽度和颜色 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: #f5f5f5;
}

/* 设置滑块的颜色 */
::-webkit-scrollbar-thumb {
  background-color: #ff0000;
}

/* 设置滑道上未被滑块覆盖部分的颜色 */
::-webkit-scrollbar-track {
  background-color: #d9d9db;
}
</style>
